// DirectorTour.jsx

import React from "react";
import "./TourPages.css";
import Footer from "../../components/NonLoggedFooter";
import Navigation from "../../RootNavigation";
import DirectorHero from "../../assets/director-tour.jpg";

export default function DirectorTour() {
  return (
    <>
    <Navigation />
      <section className="tour-hero">
        <img
          src={DirectorHero}
          alt="Casting Director Tour"
          className="tour-hero-image"
        />

        <div className="tour-hero-overlay">
          <h1>Casting Director / Creators Tour</h1>
        </div>
      </section>


      <section className="tour-container " >
<p class="notice-text">
  You can send us a casting notice to post at 
  <a href="mailto:casting@directsubmit.com"> casting@directsubmit.com</a>,
  or you can log in to your NYCastings account and post it yourself.  
  <p>
  If you’ve never had an account with DirectSubmit / NYCastings, you can <a href="/signup">create one now and post a notice.</a></p>
</p>
        <p>
          For over 26 years, DirectSubmit has connected casting professionals
          with serious on-camera talent nationwide.
        </p>

        <p>
          We provide a streamlined, professional casting platform where casting
          directors, producers, filmmakers, photographers, theatre companies,
          commercial producers, and content creators can post casting notices
          and receive organized, trackable submissions.
        </p>

        <p className="tour-highlight">
          DirectSubmit is built for professionals who need results.
        </p>

        <h3>Post Casting Notices Nationwide</h3>

        <p>
          Reach actors, models, dancers, singers, and voice-over artists across
          the United States — or target specific cities and regions.
        </p>

        <h3>Create detailed casting breakdowns including:</h3>

        <ul>
          <li>Role descriptions</li>
          <li>Age ranges</li>
          <li>Compensation</li>
          <li>Union / Non-Union status</li>
          <li>Shoot dates & locations</li>
          <li>Self-tape instructions</li>
        </ul>

        <p>
          Your project is presented clearly to qualified talent, reducing
          confusion and increasing submission quality.
        </p>

        <h3>Receive Organized, Filterable Submissions</h3>

        <ul>
          <li>Review headshots, reels, and résumés instantly</li>
          <li>Request self-tapes and snapshots</li>
          <li>Sort and organize candidates efficiently</li>
          <li>Message talent directly through the platform</li>
          <li>Track and manage your casting process in one place</li>
        </ul>

        <h3>Discover Talent Beyond Submissions</h3>

        <p>
          Search the DirectSubmit database anytime to proactively find
          performers who match your needs.
        </p>

        <h3>Filter by:</h3>

        <ul>
          <li>Location</li>
          <li>Experience</li>
          <li>Special skills</li>
          <li>Physical attributes</li>
          <li>Representation</li>
          <li>Media availability</li>
        </ul>

        <h3>Secure & Professional Environment</h3>

        <p>
          DirectSubmit provides a structured, secure space where professional
          casting and professional talent meet.
        </p>

        <h3>Built for Today’s Productions</h3>

        <p>
          Whether you’re casting a national commercial, an independent film, a
          branded content campaign, or a theatre production, DirectSubmit helps
          you move quickly and efficiently.
        </p>

        <p className="tour-highlight">
          Post. Review. Message. Cast.
        </p>
      </section>

      <Footer />
    </>
  );
}